import { Injector } from "@angular/core";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { BaseNode } from "../../BaseNode";
import { ScientificProductsEntity } from "../../../Data/MedicinalProductData/ScientificProductsEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { DateUtil } from "../../../DateUtil";
import { TreeNodeMedicinalProductsAbstractAuthorisedProductList } from "../ListEntity/TreeNodeMedicinalProductsAbstractAuthorisedProductList";
import { AuthorisedProductAutoUploadEntity } from "./AuthorisedProductAutoUploadEntity";
import { DevelopmentProductAutoUploadEntity } from "./DevelopmentProductAutoUploadEntity";
import { AbstractPharmaceuticalProductsStrengthAutoUploadList } from "./AbstractPharmaceuticalProductsStrengthAutoUploadList";
import { TreeNodeMedicinalProductsAbstractDevelopmentProductList } from "../ListEntity/TreeNodeMedicinalProductsAbstractDevelopmentProductList";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";


export class AbstractPharmaceuticalProductsStrengthAutoUploadEntity extends OnDemandAutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload:boolean, cloninNode: boolean) {
        super(injector, 
            labelTemplate, 
            ScientificProductsEntity, 
            AutoUploadEntityEnum.abstractPharmaceuticalProductsStrength, 
            ServiceEnum.MedicinalProducts, 
            parent, 
            model, 
            AbstractPharmaceuticalProductsStrengthAutoUploadEntity,
            true, 
            disableAutoUpload,
            cloninNode,
            {});
            this.useHist = useHist;
    }

    filterData(model: any) {
        const pkProductsFound = model.filter((item:any)=>item.pk_product !== null);
        const uniqueByPkProduct = pkProductsFound.filter((item: any, index: number, self:any) =>
        index === self.findIndex((t: any) => t.pk_product === item.pk_product)
        );
        return uniqueByPkProduct;        

    }

    override postLoadEntity(model: any): void {
        // ignore model we need to process parent node dataSource with this entity own filter
        const modelToProcess = this.filterData((this.parent! as AbstractPharmaceuticalProductsStrengthAutoUploadList).dataSource);
        const authorisedListNode = new TreeNodeMedicinalProductsAbstractAuthorisedProductList(this.ioc!,this);
        const developmentListNode = new TreeNodeMedicinalProductsAbstractDevelopmentProductList(this.ioc!,this);
        this.children?.push(authorisedListNode);
        this.children?.push(developmentListNode);

        modelToProcess.forEach((item:any) => {
            if (item.type_product === 2) {
                const labelTemplate = `Authorised - ${item.ev_Code} - ${item.version} - ${item.productname}`;
                authorisedListNode.children?.push(new AuthorisedProductAutoUploadEntity(this.ioc!, `${labelTemplate}`,authorisedListNode,{...item, id: item.pk_product}, this.useHist, false, false));
            } else if (item.type_product === 1) {
                const labelTemplate = `Development - ${item.ev_Code} - ${item.version} - ${item.productname}`;
                developmentListNode.children?.push(new DevelopmentProductAutoUploadEntity(this.ioc!, `${labelTemplate}`,developmentListNode,{...item, id: item.pk_product}, this.useHist, false, false));
            }            
        });

        const authorisedNumItems: string = authorisedListNode.children?authorisedListNode.children.length.toString():'0'; 
        authorisedListNode.label = authorisedListNode.labelTemplate + ' (' + authorisedNumItems + ')';
        authorisedListNode.refreshLabel();

        const developmentNumItems: string = developmentListNode.children?developmentListNode.children.length.toString():'0'; 
        developmentListNode.label = developmentListNode.labelTemplate + ' (' + developmentNumItems + ')';
        developmentListNode.refreshLabel();

        this.label = this.labelTemplate;
        this.refreshLabel();

    }

    public getListItem(): any[] {
        return [this.data.model.scientificname,
        this.data.model.scientificcode,
        this.data.model.scientificstrength,
        this.data.model.name_pharmform,
        this.data.model.ownerhqid,
        this.ioc!.get(LookupGetService).retrieveValueFromCache('substancestypes', this.data.model.is_development),
        this.ioc!.get(LookupGetService).retrieveValueFromCache('pispStatus', this.data.model.status),
        DateUtil.getYesNoDateTimeFormat(this.data.model.stamp_nullif)
        ];
    }

    override getOnDemandEntities() {
        let onDemandEntities: any = {};
        if (this.isLoaded) {
          this.children?.forEach((child: any) => {
            onDemandEntities = {...onDemandEntities, ...child.getOnDemandEntities()};
          });
        } 

        return {...this.datasource, ...onDemandEntities};
    }

}